import {defineStore} from "pinia";


export const usePayments = defineStore('payments', {
    state: () => ({}),
    actions: {
        async activeSubscriptions(params) {
            const {data, error} = await useApi().post('/subscriptions', params)
            return {error: error.value, data: data.value}
        },
        async requestBuy(id, params) {
            const {data, error} = await useApi().post(`/posts/${id}/request_payment`, params)
            return {error: error.value, data: data.value}
        }
    }
});
